"use client";

import { CheckCircleIcon, XCircleIcon } from "lucide-react";

interface StatusBadgeProps {
  type: "pending" | "failed" | "success";
  message: string;
  className?: string;
  testId?: string;
}

export function StatusBadge({ type, message, className = "", testId }: StatusBadgeProps) {
  const configs = {
    pending: {
      bgColor: "bg-yellow-50 dark:bg-yellow-900/20",
      borderColor: "border-yellow-200 dark:border-yellow-800",
      textColor: "text-yellow-700 dark:text-yellow-300",
      icon: <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" />,
    },
    failed: {
      bgColor: "bg-red-50 dark:bg-red-900/20",
      borderColor: "border-red-200 dark:border-red-800",
      textColor: "text-red-700 dark:text-red-300",
      icon: <XCircleIcon className="w-4 h-4" />,
    },
    success: {
      bgColor: "bg-green-50 dark:bg-green-900/20",
      borderColor: "border-green-200 dark:border-green-800", 
      textColor: "text-green-700 dark:text-green-300",
      icon: <CheckCircleIcon className="w-4 h-4" />,
    },
  };

  const config = configs[type];

  return (
    <div className={`text-center ${className}`}>
      <div 
        className={`inline-flex items-center gap-2 ${config.bgColor} border ${config.borderColor} px-4 py-2 rounded-full text-sm ${config.textColor}`}
        data-testid={testId}
      >
        {config.icon}
        {message}
      </div>
    </div>
  );
}
